export const COMPANY_INPUT_MAX_LENGTH = 50;
